import {
  BaseFieldMappingFieldProps,
  ExtendedFieldMappingEditorValue,
  FieldMappingData,
  transformSimpleValueInput,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';

const tag = 'field-mapping-placeholder';

export type FieldMappingListFieldProps = BaseFieldMappingFieldProps<
  ExtendedFieldMappingEditorValue[]
> &
  FieldMappingData;

export const FieldMappingListField = ({
  onChange,
  defaultValue,
  ...rest
}: FieldMappingListFieldProps) => {
  return (
    <NodeStyledFieldMappingTextEditor
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      defaultValue={
        defaultValue ? transformSimpleValueInput(defaultValue, (value) => value) : undefined
      }
      shouldHideMenu
      disabled
      shouldShowFieldMappingOnFocus
      {...rest}
    />
  );
};
